import {CompaniesSelectorListType} from 'src/layouts/main-layout/companies-selector/types/companies-selector-list.type'
import api, {Company} from 'src/services/api'

const mapper = (res: Company[]) => {
  return res.map((company) => {
    return {
      id: company.id,
      name: company.name,
    } as CompaniesSelectorListType
  })
}

export async function getCompaniesHttp() {
  return await api.company.getMany({orderBy: {names: 'ASC'}, pageSize: 100, page: 1}).then((res) => mapper(res.data.data.entities))
}
